// extracted by mini-css-extract-plugin
export default {"container":"style_container__0JyUQ","main":"style_main__iUd0F"};